import { supabase } from '../supabaseClient'

//Todo: Handle error
let cachedExcerpts;
async function getExcerpts(fetchLatestData) {
    if (fetchLatestData || !cachedExcerpts) {
        let { data:excerpt_with_tags, error } = await supabase
            .from('excerpt_with_tags')
            .select('*')
        cachedExcerpts = excerpt_with_tags;
        if (error) {
            console.warn(error);
        }
    }
    console.debug(cachedExcerpts);
    return cachedExcerpts;
} 


async function upsertTags(inputData) {
    const { data: response, error: error } = await supabase
        .from('tag')
        .upsert(inputData, {upsert: true}, {returning: 'representation'});
    let tagIDs = [];
    
    if (response) {
        for (let i = 0; i < response.length; i++) {
            tagIDs.push(response[i].id);
        }
        console.debug('Inserted tags with IDs: ' + tagIDs);
    } else {
        console.warn('Error inserting tags: ');
        console.warn(inputData);
        console.warn(error);
        throw error;
    }
    return tagIDs;
}

async function insertExcerpt(inputData) {
    const { data: response, error: error } = await supabase
        .from('excerpt')
        .upsert(inputData, {upsert: true}, {returning: 'representation'});
    let excerptID = response[0].id;
    if (response) {
        console.debug('Inserted excerpt with ID: ' + excerptID);
    } else {
        console.warn('Error inserting excerpt: ');
        console.warn(inputData);
        console.warn(error);
        throw error;
    }
    return excerptID;
}

async function insertExcerptTagRel(inputData) {
    const { data: response, error: error } = await supabase
        .from('excerpt_tag')
        .upsert(inputData, {upsert: true}, {returning: 'representation'});
    if (response) {
        console.debug('Inserted excerpt_tags');
        return true;
    } else {
        console.warn('Error inserting excerpt_tag: ');
        console.warn(inputData);
        console.warn(error);
        return false;
    }
}

async function deleteExcerpt(id) {
    let success = false;
    try {
        const { data: response, error: error } = await supabase
            .from('excerpt')
            .delete()
            .eq('id', id);
        
        if (response) {
            if (response.length == 1) {
                success = true;
                console.debug('Deleted excerpt ID ' + id);
            } else if (response.length = 0) {
                console.warn('Error deleting Excerpt, ID: ' + id);
                console.warn(error);
                console.warn(response);
            } else {
                console.warn('Multiple excerpts deleted, ID: ' + id);
                console.warn(error);
                console.warn(response);
            }
        } else {
            console.warn(error);
        }
    } catch (error) {
        console.warn('Unable to delete excerpt with ID ' + id);
        console.warn(error);
    }
    return {success};
}

/**
 * @param data.excerpt
 * @param data.description
 * @param data.source
 * @param data.tags
 */
 async function addExcerpt(data) {
    let tags = data.tags; //Object array: {'name' : 'color'}

    const user = supabase.auth.user();

    let tagsData = [];
    let existingTagIds = [];

    //Add only new tags
    for (let tag of tags) {
        if (tag.index) {
            console.debug('Tag ' + tag.value + ' exists, so not updating');
            existingTagIds.push(tag.index);
        } else {
            tagsData.push({'name': tag.value, 'color': tag.color, 'user_id': user.id});
        }
    }
    //Upsert tags
    let newTagIds = await upsertTags(tagsData);
    let tagIDs = existingTagIds.concat(newTagIds);
    console.debug('Upserted tags');

    //Insert excerpt
    let excerptsData = {
        user_id: user.id,
        excerpt: data.excerpt,
        source: data.source,
        description: data.description
    };
    let excerptID = await insertExcerpt(excerptsData);
    console.debug('Upserted excerpt: ' + excerptID);

    //Insert excerptTagRels
    let excerptTagRelsData = [];
    for (let i = 0; i < tagIDs.length; i++) {
        excerptTagRelsData.push({'user_id': user.id, 'excerpt_id': excerptID, 'tag_id': tagIDs[i]});
    }
    console.debug(excerptTagRelsData);
    let excerptTagRelsStatus = await insertExcerptTagRel(excerptTagRelsData);

    console.debug('Insert status for: ' + excerptsData.excerpt.substring(0,20) + '..., ' + excerptTagRelsStatus);
}

function extractText(inputText) {
    inputText = inputText.trim();
    let result = {
        text: inputText,
        source: ''
    }
    //Chrome format: `"<text>" <link>`
    try {
        let link = inputText.substring(inputText.lastIndexOf('http'));
        let urlObject = new URL(link);
        let remainingText = inputText.substring(0, inputText.lastIndexOf('http')).trim();
        //Check for enclosing quotes and remove them
        if (remainingText.charAt(0) == '"' && remainingText.charAt(remainingText.length - 1) == '"') {
            result.text = remainingText.substring(1, remainingText.length - 1);
            result.source = link;
        }
    } catch (error) {
        //Well, it isn't from Chrome.
    }
    return result;
}


let util = { 
    getExcerpts,
    addExcerpt,
    extractText,
    deleteExcerpt
};

export { util };